/**
 * Dashboard Store
 * Zustand store for real-time dashboard state management
 */

import { create } from 'zustand';

import type {
  AgentCounts,
  AgentTrends,
  DashboardState,
} from '../types/dashboard';

interface DashboardStore extends DashboardState {
  // Actions
  setAgentCounts: (counts: AgentCounts) => void;
  setAgentTrends: (trends: AgentTrends) => void;
  setLoading: (loading: boolean) => void;
  setError: (error: Error | null) => void;
  clearError: () => void;
  reset: () => void;
}

const initialState: DashboardState = {
  agents: [],
  counts: {
    total: 0,
    online: 0,
    offline: 0,
    error: 0,
  },
  trends: {
    total: 0,
    online: 0,
    offline: 0,
    error: 0,
  },
  isLoading: false,
  error: null,
};

export const useDashboardStore = create<DashboardStore>(set => ({
  ...initialState,

  setAgentCounts: (counts: AgentCounts) =>
    set(state => ({
      ...state,
      counts,
    })),

  setAgentTrends: (trends: AgentTrends) =>
    set(state => ({
      ...state,
      trends,
    })),

  setLoading: (loading: boolean) =>
    set(state => ({
      ...state,
      isLoading: loading,
    })),

  setError: (error: Error | null) =>
    set(state => ({
      ...state,
      error,
    })),

  clearError: () =>
    set(state => ({
      ...state,
      error: null,
    })),

  reset: () => set(initialState),
}));
